import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { UserGroupEffects } from './user-group.effects';
import { userGroupReducer } from './user-group.reducer';

export const provideUserGroupStore = () => [
  provideState('userGroups', userGroupReducer),
  provideEffects([UserGroupEffects]),
];
